import React from 'react';

import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, ErrorBar, Cell } from 'recharts';

export const ROIHatChart = ({ ROIHatData = undefined, isConversionKPI }) => {
  // eslint-disable-next-line react/no-unstable-nested-components
  const ROITooltip = ({ active, payload }) => {
    const format = v => v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (active && payload && payload.length) {
      const { confidence } = payload[0].payload;
      const { value } = payload[0];
      return (
        <div className="roi-tooltip">
          <p>{`${isConversionKPI ? 'CPA' : 'ROI'} : ${isConversionKPI ? '$' : ''}${format(value)}`}</p>
          <p>
            90% credibility interval:
            {' '}
            {isConversionKPI ? '$' : ''}
            {format(value - confidence[0])}
            {' '}
            -
            {' '}
            {isConversionKPI ? '$' : ''}
            {format(value + confidence[1])}
          </p>
        </div>
      );
    }
    return null;
  };

  if (!ROIHatData || !ROIHatData.length) return null;
  const chartData = ROIHatData.sort((a, b) => a.feature - b.feature).map(x => (
    { roi: x.roi, confidence: [x.q05, x.q95], name: x.feature }
  ));

  if (isConversionKPI) {
    chartData.forEach(accu => {
      const [q05, q95] = accu.confidence;
      const cpa = 1 / accu.roi;
      accu.confidence = [cpa - (1 / (q95 + accu.roi)), (1 / (accu.roi - q05) - cpa)];
      accu.roi = cpa;
    });
  }

  return (
    <div style={{ width: '100%', marginLeft: '130px' }}>
      <ResponsiveContainer width="70%" height={100}>
        <BarChart data={chartData} layout="vertical">
          <XAxis type="number" />
          <YAxis dataKey="name" type="category" display="none" />
          <Tooltip content={<ROITooltip />} />
          <Bar dataKey="roi" fill="#8884d8">
            {chartData.map(entry => (
              <Cell key={`cell-${entry.name}`} fill="#8884d8" />
            ))}
            <ErrorBar dataKey="confidence" width={4} strokeWidth={2} stroke="black" />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
